<template lang="pug">
.media-detail
  MediaViewer(
    :media-url="mediaUrl"
    :is-video="media.type === 'video'"
    :faces="media.faces"
    :selected-face="selectedFace"
    :scale="scale"
    :translate-x="translateX"
    :translate-y="translateY"
    :admin-mode="adminMode"
    :groups="groups"
    :editing-face-index="editingFaceIndex"
    @face-clicked="selectFace"
    @edit-face="renameFace"
    @image-loaded="onImageLoaded"
    @drag="onDrag"
  )
</template>

<script>
import MediaViewer from './MediaViewer.vue';

export default {
  components: { MediaViewer },
  props: {
    media: Object,
    adminMode: Boolean,
    groups: Array
  },
  data() {
    return {
      scale: 1,
      translateX: 0,
      translateY: 0,
      selectedFace: null,
      editingFaceIndex: null,
      imageSize: null
    };
  },
  computed: {
    mediaUrl() {
        return `https://gnatowski.ddns.net/api/media/content/${this.media.id}`
    }
  },
  methods: {
    selectFace(face) {
      if (this.selectedFace?.index === face.index && this.adminMode) {
        this.editingFaceIndex = face.index;
      } else {
        this.selectedFace = face;
        this.editingFaceIndex = null;
      }
    },
    renameFace({ index, name }) {
      const face = this.media.faces.find(f => f.index === index);
      if (face) {
        this.$emit('update-face', { mediaId: this.media.id, index, name });
        this.editingFaceIndex = null;
      }
    },
    onImageLoaded({ width, height }) {
      this.imageSize = { width, height };
    },
    onDrag({ dx, dy }) {
      this.translateX += dx / this.scale;
      this.translateY += dy / this.scale;
    }
  }
};
</script>

<style scoped lang="less">
.media-detail {
    flex: 1 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 10px solid blue;
}
</style>
